import { EvidencesTypeValueEnum } from '@/utils/enums/evidences'
import { PlanEvidence, PlanIncludeOption, PlanItem } from './types'

export const PLAN_EVIDENCE_TYPE_TO_ID: Record<PlanEvidence['id'], number> = {
  image: EvidencesTypeValueEnum.IMAGE,
  video: EvidencesTypeValueEnum.VIDEO,
  sign: EvidencesTypeValueEnum.SIGN,
  document: EvidencesTypeValueEnum.DOCUMENT,
  comment: EvidencesTypeValueEnum.COMMENT,
}

export const PLAN_INCLUDE_OPTIONS: { id: PlanIncludeOption; translationIndex: number }[] = [
  { id: 'items', translationIndex: 0 },
  { id: 'linkQuestionnaire', translationIndex: 1 },
  { id: 'evidences', translationIndex: 2 },
  { id: 'solverEvidences', translationIndex: 3 },
]

export const DEFAULT_PLAN_ITEMS: PlanItem[] = [
  { id: 'what', label: 'actionPlan.manualCreation.items.list.what', answer: '', selected: false },
  { id: 'where', label: 'actionPlan.manualCreation.items.list.where', answer: '', selected: false },
  { id: 'when', label: 'actionPlan.manualCreation.items.list.when', answer: '', selected: false },
  { id: 'howMuch', label: 'actionPlan.manualCreation.items.list.howMuch', answer: '', selected: false },
  { id: 'why', label: 'actionPlan.manualCreation.items.list.why', answer: '', selected: false },
  { id: 'who', label: 'actionPlan.manualCreation.items.list.who', answer: '', selected: false },
  { id: 'how', label: 'actionPlan.manualCreation.items.list.how', answer: '', selected: false },
  { id: 'observations', label: 'actionPlan.manualCreation.items.list.observations', answer: '', selected: false },
]

export const DEFAULT_PLAN_EVIDENCES: PlanEvidence[] = [
  { id: 'image', label: 'actionPlan.manualCreation.evidences.types.image', files: [], comments: [] },
  { id: 'video', label: 'actionPlan.manualCreation.evidences.types.video', files: [], comments: [] },
  { id: 'sign', label: 'actionPlan.manualCreation.evidences.types.sign', files: [], comments: [] },
  { id: 'document', label: 'actionPlan.manualCreation.evidences.types.document', files: [], comments: [] },
  { id: 'comment', label: 'actionPlan.manualCreation.evidences.types.comment', files: [], comments: [] },
]
